// extracted by mini-css-extract-plugin
module.exports = {"link":"dd31006766--link--8fZB4"};